import React from 'react';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import { SvgSprite } from 'modules/svgSprite';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import type { ProductStockCheckMarkType } from 'autogen/swagger/all';
import { em } from 'modules/helpers/style';
import type { ProductStockStatusType } from 'autogen/swagger/all';
import { useRecoilValue } from 'recoil';
import { requestDataState } from 'recoilState/atoms/requestDataState';
import Bullet from 'components/Bullet';
import type { BulletProps } from 'components/Bullet/Bullet';

type UnifyStockStatusType = ProductStockCheckMarkType | ProductStockStatusType;

const getIndicatorColor = (type?: UnifyStockStatusType): BulletProps['color'] => {
    switch (type) {
        case 'Green':
        case 'IsInStock':
            return 'Green';
        case 'Yellow':
        case 'FewInStock':
            return 'Yellow';
        case 'Red':
        case 'SoldOut':
            return 'Red';
        case 'Black':
        default:
            return 'Black';
    }
};

const Checkmark = styled(SvgSprite)`
    display: inline;
    width: 100%;
    height: 100%;
    max-width: 12px;
    max-height: 12px;
    margin-right: 5px;

    ${breakpoint.up(sizes.md)} {
        max-width: 16px;
        max-height: 16px;
    }
`;

const StyledDot = styled(Bullet)`
    margin-right: ${Spacing8};
    margin-top: ${em(6)};
`;

interface IStockIndicator {
    checkmarkType?: UnifyStockStatusType;
    useDot?: boolean;
}

export default function StockIndicator({ checkmarkType, useDot = false }: IStockIndicator): JSX.Element {
    const state = useRecoilValue(requestDataState);
    const brand = state?.javascriptPageContext?.brandContext;

    const type = brand === 'chanel' ? 'Black' : checkmarkType;

    if (useDot) {
        return <StyledDot size={6} color={getIndicatorColor(type)} />;
    }

    return <Checkmark sprite="Checkmark" fill={getIndicatorColor(type)} />;
}
